import { FunctionComponent } from "react";
import classes from "./index.module.css";
import { Card, CardContent, Divider } from "@material-ui/core";
import { translate, formaterPhoneNumber } from "../../../../utils/helpers";
import jMoment from "moment-jalaali";
import handleError from "../../../../utils/handleError";
import getParcelFileReq from "client-sdk/src/parcels/file";

interface ParcelInfoCardProps {
  parcel: any;
  inventoryItemsCount: number;
}

const ParcelInfoCard: FunctionComponent<ParcelInfoCardProps> = ({
  parcel,
  inventoryItemsCount,
}) => {
  const downloadDigiFile = async () => {
    try {
      const response = await getParcelFileReq(parcel.id);
      const file = URL.createObjectURL(response.blob);
      const link = document.createElement("a");
      link.href = file;
      link.setAttribute("download", parcel?.labelFileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Card style={{ position: "sticky", top: "80px" }}>
      <CardContent>
        {/* <div className={classes.item}>
      <span className={classes.label}>{'وضعیت تحویل:  '}</span>
      <span style={{ flex: 1 }}>
        {translate(parcel.status, 'parcel')}
      </span>
    </div>
    <div className={classes.item}>
      <span className={classes.label}>{'انبار مقصد:  '}</span>

      <span style={{ flex: 1 }}>{parcel.destinationName}</span>
    </div> */}
        <div className={classes.item}>
          <span className={classes.label}>{"نوع ارسال:  "}</span>

          <span style={{ flex: 1 }}>{parcel.courierName || "-"}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{"نوع ورود:  "}</span>

          <span style={{ flex: 1 }}>{parcel.fulfillmentTypeName || "-"}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{" تنوع کالا:  "}</span>

          <span style={{ flex: 1 }}>{parcel?.items?.length}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{"تعداد آیتم ها:  "}</span>

          <span style={{ flex: 1 }}>{inventoryItemsCount}</span>
        </div>
        {/* <div className={classes.item}>
      <span className={classes.label}>{'نوع ارسال:  '}</span>
      <span style={{ flex: 1 }}>{translate(parcel.deliveryType)}</span>
    </div>
    <div className={classes.item}>
      <span className={classes.label}>{'شناسه:  '}</span>

      <span style={{ flex: 1 }}>{parcel.id}</span>
    </div> */}
        <Divider style={{ width: "100%", marginBottom: "24px" }} />
        {/* <div className={classes.item}>
      <span className={classes.label}>{'تاریخ ثبت:  '}</span>
      <span style={{ flex: 1 }}>
        {parcel.deliveryDate &&
          `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
            .locale('fa')
            .format('jYYYY/jMM/jDD')}`}
      </span>
    </div> */}
        <div className={classes.item}>
          <span className={classes.label}>{"تاریخ تحویل:  "}</span>
          <span style={{ flex: 1 }}>
            {parcel.shippingDate &&
              `${jMoment(parcel.deliveryDate, "YYYY/MM/DD")
                .locale("fa")
                .format("jYYYY/jMM/jDD")}`}
          </span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{"بازه تحویل:  "}</span>
          <span style={{ flex: 1 }}>
            {parcel.deliveryStartTime &&
              jMoment(parcel.deliveryStartTime, "hh:mm")
                .locale("fa")
                .format("HH:mm")}
            {" - "}
            {parcel.deliveryEndTime &&
              jMoment(parcel.deliveryEndTime, "hh:mm")
                .locale("fa")
                .format("HH:mm")}
          </span>
        </div>
        <Divider style={{ width: "100%", marginBottom: "24px" }} />
        <div className={classes.item}>
          <span className={classes.label}>{"تعداد بسته:"}</span>
          <span style={{ flex: 1 }}>
            {parcel?.parcelPackages?.map((el: any) => (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span className="ml-1">{el?.count}</span>
                <span className="ml-1">{`${el.length}×${el.height}×${el.width}`}</span>
                <span>{el.weight}</span>
              </div>
            ))}
          </span>
        </div>
        <Divider style={{ width: "100%", marginBottom: "24px" }} />
        <div className={classes.item}>
          <span className={classes.label}>{"ارسال کننده:  "}</span>
          <span style={{ flex: 1 }}>
            {parcel.partnerName ?? parcel.sellerName}
          </span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{"نام مسئول حمل:  "}</span>

          <span style={{ flex: 1 }}>{parcel.agentName}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.label}>{"شماره همراه:  "}</span>
          <span style={{ flex: 1 }}>
            {formaterPhoneNumber(parcel.agentPhoneNumber)}
          </span>
        </div>
        <Divider style={{ width: "100%", marginBottom: "24px" }} />
        {/* <div className={classes.item}>
      <span className={classes.label}>{'آدرس انبار :  '}</span>
      <span style={{ flex: 1 }}>{parcel.destinationAddress}</span>
    </div> */}
        <div className={classes.item}>
          <span className={classes.label}>{"توضیحات :  "}</span>
          <span style={{ flex: 1 }}>{parcel?.description}</span>
        </div>
        {parcel?.labelFileName && (
          <div className={classes.item}>
            <span className={classes.label}>{"فایل دیجی‌کالا :  "}</span>
            <span
              style={{ flex: 1 }}
              className="link"
              onClick={downloadDigiFile}>
              {parcel?.labelFileName}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ParcelInfoCard;
